import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FilePdf, DownloadSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getMonday(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  return d;
}

export function RelatoriosPdfTab() {
  const [selectedDate, setSelectedDate] = useState(() => getMonday(new Date()).toISOString().split("T")[0]);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const response = await axios.get(`${API}/tasks/report/pdf`, {
        params: { start_date: selectedDate },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `agenda_semanal_${selectedDate}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("PDF gerado com sucesso");
    } catch (error) {
      toast.error("Erro ao gerar o PDF");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-8 text-center" data-testid="relatorios-pdf-tab">
      <div className="p-4 bg-[#009392]/10 rounded-2xl w-16 h-16 mx-auto mb-4 flex items-center justify-center">
        <FilePdf size={28} className="text-[#009392]" />
      </div>
      <h3 className="text-lg font-semibold text-stone-800 mb-1">Relatório de Agenda Semanal</h3>
      <p className="text-sm text-stone-500 mb-6">
        Escolha qualquer dia da semana desejada e baixe o PDF com todas as tarefas agendadas (Segunda a Sexta).
      </p>
      <div className="space-y-1.5 text-left mb-6">
        <Label>Semana de</Label>
        <Input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          data-testid="report-week-date-input"
        />
      </div>
      <Button className="w-full btn-primary" onClick={handleDownload} disabled={downloading} data-testid="btn-download-agenda-pdf">
        <DownloadSimple size={16} className="mr-2" />
        {downloading ? "A gerar PDF..." : "Baixar PDF"}
      </Button>
    </div>
  );
}
